/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { CollectionGrantFragmentDoc } from "../../../../mutations/collections.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type AddToCollectionLinkFragment = {
  readonly __typename: "CollectionHexLink";
  readonly id: c.CollectionHexLinkId;
  readonly projectRole: Types.ProjectRole | null;
  readonly collection: {
    readonly __typename: "Collection";
    readonly id: c.CollectionId;
    readonly name: string;
    readonly emoji: string | null;
    readonly canManage: boolean;
    readonly collectionGrants: ReadonlyArray<{
      readonly __typename: "CollectionGrant";
      readonly id: c.CollectionGrantId;
      readonly role: Types.CollectionRole;
      readonly holder:
        | {
            readonly __typename: "Group";
            readonly groupId: c.GroupId;
            readonly groupName: string;
          }
        | {
            readonly __typename: "IntrinsicGroup";
            readonly intrinsicGroupId: Types.IntrinsicGroupId;
          }
        | {
            readonly __typename: "User";
            readonly name: string | null;
            readonly email: string;
            readonly active: boolean;
            readonly imageUrl: string | null;
            readonly orgRole: Types.OrgRole;
            readonly userId: c.UserId;
          };
    }>;
  };
};

export type HexForAddToCollectionsDialogQueryVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
}>;

export type HexForAddToCollectionsDialogQuery = {
  readonly __typename: "Query";
  readonly hexById: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly collectionHexLinks: ReadonlyArray<{
      readonly __typename: "CollectionHexLink";
      readonly id: c.CollectionHexLinkId;
      readonly projectRole: Types.ProjectRole | null;
      readonly collection: {
        readonly __typename: "Collection";
        readonly id: c.CollectionId;
        readonly name: string;
        readonly emoji: string | null;
        readonly canManage: boolean;
        readonly collectionGrants: ReadonlyArray<{
          readonly __typename: "CollectionGrant";
          readonly id: c.CollectionGrantId;
          readonly role: Types.CollectionRole;
          readonly holder:
            | {
                readonly __typename: "Group";
                readonly groupId: c.GroupId;
                readonly groupName: string;
              }
            | {
                readonly __typename: "IntrinsicGroup";
                readonly intrinsicGroupId: Types.IntrinsicGroupId;
              }
            | {
                readonly __typename: "User";
                readonly name: string | null;
                readonly email: string;
                readonly active: boolean;
                readonly imageUrl: string | null;
                readonly orgRole: Types.OrgRole;
                readonly userId: c.UserId;
              };
        }>;
      };
    }>;
  };
};

export type AddCollectionsToHexMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  appUserCollectionIds:
    | ReadonlyArray<Types.Scalars["CollectionId"]["input"]>
    | Types.Scalars["CollectionId"]["input"];
  viewerCollectionIds:
    | ReadonlyArray<Types.Scalars["CollectionId"]["input"]>
    | Types.Scalars["CollectionId"]["input"];
  editorCollectionIds:
    | ReadonlyArray<Types.Scalars["CollectionId"]["input"]>
    | Types.Scalars["CollectionId"]["input"];
  ownerCollectionIds:
    | ReadonlyArray<Types.Scalars["CollectionId"]["input"]>
    | Types.Scalars["CollectionId"]["input"];
  noAddedGrantCollectionIds:
    | ReadonlyArray<Types.Scalars["CollectionId"]["input"]>
    | Types.Scalars["CollectionId"]["input"];
}>;

export type AddCollectionsToHexMutation = {
  readonly __typename: "Mutation";
  readonly addCollectionsToHex: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly maxGrantableRole: Types.ProjectRole | null;
    readonly collectionHexLinks: ReadonlyArray<{
      readonly __typename: "CollectionHexLink";
      readonly id: c.CollectionHexLinkId;
      readonly projectRole: Types.ProjectRole | null;
      readonly collection: {
        readonly __typename: "Collection";
        readonly id: c.CollectionId;
        readonly name: string;
        readonly emoji: string | null;
        readonly canManage: boolean;
        readonly collectionGrants: ReadonlyArray<{
          readonly __typename: "CollectionGrant";
          readonly id: c.CollectionGrantId;
          readonly role: Types.CollectionRole;
          readonly holder:
            | {
                readonly __typename: "Group";
                readonly groupId: c.GroupId;
                readonly groupName: string;
              }
            | {
                readonly __typename: "IntrinsicGroup";
                readonly intrinsicGroupId: Types.IntrinsicGroupId;
              }
            | {
                readonly __typename: "User";
                readonly name: string | null;
                readonly email: string;
                readonly active: boolean;
                readonly imageUrl: string | null;
                readonly orgRole: Types.OrgRole;
                readonly userId: c.UserId;
              };
        }>;
      };
    }>;
  };
};

export const AddToCollectionLinkFragmentDoc = /*#__PURE__*/ gql`
  fragment AddToCollectionLinkFragment on CollectionHexLink {
    id
    projectRole
    collection {
      id
      name
      emoji
      canManage
      collectionGrants {
        id
        ...CollectionGrantFragment
      }
    }
  }
  ${CollectionGrantFragmentDoc}
`;
export const HexForAddToCollectionsDialogDocument = /*#__PURE__*/ gql`
  query HexForAddToCollectionsDialog($hexId: HexId!) {
    hexById(hexId: $hexId) {
      id
      collectionHexLinks: safeCollectionHexLinks {
        ...AddToCollectionLinkFragment
      }
    }
  }
  ${AddToCollectionLinkFragmentDoc}
`;

/**
 * __useHexForAddToCollectionsDialogQuery__
 *
 * To run a query within a React component, call `useHexForAddToCollectionsDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useHexForAddToCollectionsDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHexForAddToCollectionsDialogQuery({
 *   variables: {
 *      hexId: // value for 'hexId'
 *   },
 * });
 */
export function useHexForAddToCollectionsDialogQuery(
  baseOptions: Apollo.QueryHookOptions<
    HexForAddToCollectionsDialogQuery,
    HexForAddToCollectionsDialogQueryVariables
  > &
    (
      | {
          variables: HexForAddToCollectionsDialogQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    HexForAddToCollectionsDialogQuery,
    HexForAddToCollectionsDialogQueryVariables
  >(HexForAddToCollectionsDialogDocument, options);
}
export function useHexForAddToCollectionsDialogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HexForAddToCollectionsDialogQuery,
    HexForAddToCollectionsDialogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    HexForAddToCollectionsDialogQuery,
    HexForAddToCollectionsDialogQueryVariables
  >(HexForAddToCollectionsDialogDocument, options);
}
export function useHexForAddToCollectionsDialogSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    HexForAddToCollectionsDialogQuery,
    HexForAddToCollectionsDialogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    HexForAddToCollectionsDialogQuery,
    HexForAddToCollectionsDialogQueryVariables
  >(HexForAddToCollectionsDialogDocument, options);
}
export type HexForAddToCollectionsDialogQueryHookResult = ReturnType<
  typeof useHexForAddToCollectionsDialogQuery
>;
export type HexForAddToCollectionsDialogLazyQueryHookResult = ReturnType<
  typeof useHexForAddToCollectionsDialogLazyQuery
>;
export type HexForAddToCollectionsDialogSuspenseQueryHookResult = ReturnType<
  typeof useHexForAddToCollectionsDialogSuspenseQuery
>;
export type HexForAddToCollectionsDialogQueryResult = Apollo.QueryResult<
  HexForAddToCollectionsDialogQuery,
  HexForAddToCollectionsDialogQueryVariables
>;
export const AddCollectionsToHexDocument = /*#__PURE__*/ gql`
  mutation AddCollectionsToHex(
    $hexId: HexId!
    $appUserCollectionIds: [CollectionId!]!
    $viewerCollectionIds: [CollectionId!]!
    $editorCollectionIds: [CollectionId!]!
    $ownerCollectionIds: [CollectionId!]!
    $noAddedGrantCollectionIds: [CollectionId!]!
  ) {
    addCollectionsToHex(
      hexId: $hexId
      appUserCollectionIds: $appUserCollectionIds
      viewerCollectionIds: $viewerCollectionIds
      editorCollectionIds: $editorCollectionIds
      ownerCollectionIds: $ownerCollectionIds
      noAddedGrantCollectionIds: $noAddedGrantCollectionIds
    ) {
      id
      maxGrantableRole
      collectionHexLinks: safeCollectionHexLinks {
        ...AddToCollectionLinkFragment
      }
    }
  }
  ${AddToCollectionLinkFragmentDoc}
`;
export type AddCollectionsToHexMutationFn = Apollo.MutationFunction<
  AddCollectionsToHexMutation,
  AddCollectionsToHexMutationVariables
>;

/**
 * __useAddCollectionsToHexMutation__
 *
 * To run a mutation, you first call `useAddCollectionsToHexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCollectionsToHexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCollectionsToHexMutation, { data, loading, error }] = useAddCollectionsToHexMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      appUserCollectionIds: // value for 'appUserCollectionIds'
 *      viewerCollectionIds: // value for 'viewerCollectionIds'
 *      editorCollectionIds: // value for 'editorCollectionIds'
 *      ownerCollectionIds: // value for 'ownerCollectionIds'
 *      noAddedGrantCollectionIds: // value for 'noAddedGrantCollectionIds'
 *   },
 * });
 */
export function useAddCollectionsToHexMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddCollectionsToHexMutation,
    AddCollectionsToHexMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddCollectionsToHexMutation,
    AddCollectionsToHexMutationVariables
  >(AddCollectionsToHexDocument, options);
}
export type AddCollectionsToHexMutationHookResult = ReturnType<
  typeof useAddCollectionsToHexMutation
>;
export type AddCollectionsToHexMutationResult =
  Apollo.MutationResult<AddCollectionsToHexMutation>;
export type AddCollectionsToHexMutationOptions = Apollo.BaseMutationOptions<
  AddCollectionsToHexMutation,
  AddCollectionsToHexMutationVariables
>;
